/**
 * Formatting helpers for Beachvision UI (dates, durations, scores).
 */

export function formatDate(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatDuration(totalSeconds) {
  if (totalSeconds == null || Number.isNaN(Number(totalSeconds))) return '—';
  const s = Math.max(0, Math.floor(Number(totalSeconds)));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, '0')}`;
}

export function formatScore(value) {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return `${Math.round(Number(value))}%`;
}

export function scoreColor(score) {
  if (score == null) return 'text-beachvision-muted';
  const n = Number(score);
  if (n >= 80) return 'text-beachvision-teal';
  if (n >= 60) return 'text-beachvision-coral';
  return 'text-beachvision-coral';
}

export function formatReleaseMs(ms) {
  if (ms == null || Number.isNaN(Number(ms))) return '—';
  const sec = Number(ms) / 1000;
  return `${sec.toFixed(1)}s`;
}
